<template>
    <div class="container-md full_width">      
        <div>
            <div class="container" v-if="status === 'pending'">
                <div class="py-2">
                    <div class="step_skeleton">
                        <div class="placeholder skeleton"></div>
                        <div class="placeholder skeleton"></div>
                        <div class="placeholder skeleton"></div>
                        <div class="placeholder skeleton"></div>
                    </div>
                </div>       
            </div>
            <div v-else-if="status === 'success'">
                <div class="customer_created py-4" v-if="items?.length">
                    <h4 v-if="type === 'band'" class="mb-4 text-center"><span class="font-active"> Most Loved Wedding Rings
                        </span></h4>
                    <h4 v-if="type === 'shop'" class="mb-4 text-center"><span class="font-active">Top Trending {{
                            $t('jewelry') }} </span></h4>
                    <h4 v-if="type === 'cyor'" class="mb-4 text-center"><span class="font-active">Most Loved Engagement
                            Rings</span></h4>
    
                    <div>
                        <swiper v-bind="swiperOptions"
                         class="mySwiper">
                            <swiper-slide v-for="item in items" :key="item.id">
                                <div class="slide_box">
                                    <NuxtLink :to="localePath(getUrl(item))">
                                        <img loading="lazy" class="thumb" width="246" height="246" :src="item.front_image"
                                            :alt="item.product_name">
                                        <h5>{{ item.product_name }}</h5>
                                        <p>{{ $formatPrice(item.price) }} <span class="price">{{ $formatPrice(item.mrp)
                                                }}</span></p>
                                    </NuxtLink>
                                </div>
                            </swiper-slide>
                            <!-- <div class="arrow_block">
                            <div class="slick_arrow_up me-2" @click="showNext"><span></span></div>
                            <div class="slick_arrow_down ms-2" @click="showPrev"><span></span></div>
                        </div> -->
                        </swiper>
                    </div>
                </div>
            </div>

            <div class="" v-else>

            </div>
        </div>
    </div>
</template>

<script setup>
const localePath = useLocalePath();
const props = defineProps(['type']);
const items = ref([]);
const swiperOptions = {
    autoplay:{
            delay: 2500,
            disableOnInteraction: false,
        },
        loop:true ,
        modules:[SwiperAutoplay], 
        breakpoints:{
        0: {
        slidesPerView: 1.5,
        slidesPerGroup: 1,
        centeredSlides: true,
        },
        512: {
            slidesPerView: 3,
            slidesPerGroup: 1,
            centeredSlides: false,
        },
        992: {
            slidesPerView: 3,
            slidesPerGroup: 1,
            centeredSlides: false,
        },
        1025: {
            slidesPerView: 5,
            slidesPerGroup: 1,
            centeredSlides: false,
        }
    }
}
const getUrl = (item) => {
    if (['band', 'shop'].includes(props.type)) {
        return item.full_slug;
    }
    return item.slug;
};

    // Step 1 check status for Pending if pending show skeleton
    // step 2 check if or full data is loaded display that part
    /// step 3 show nothing if error is displayed
    // step 4 put the component out of container solo and add class of that specific for padding

    const {data, status}= await useLazyFetch(useCountryPath('/config/custom/product?module_type=' + props.type))
    if(data.value && data.value.data?.items){
        items.value = data.value.data?.items
    }
</script>


<style scoped>

.step_skeleton {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.skeleton {
    height: 361px;
    width: 345px;
    border-radius: 4px;
    background-color: rgba(0, 0, 0, 0.3);
    -webkit-mask-image: radial-gradient(white, black);
    mask-image: radial-gradient(white, black);
    cursor: wait;
    overflow: hidden;
}
.customer_created {
    padding: 4% 0 0;
}

.fade-enter-active {
    transition: opacity 0.5s ease;
}

.fade-enter,
.fade-leave-to {
    opacity: 0;
}

.slide_box {
    text-align: center;
    position: relative;
    padding: 0 10px;
}

h4,
h1 {
    font-size: 30px;
}

p {
    font-weight: 600;
    color: var(--green);
    text-align: center;
}

p span {
    text-decoration: line-through;
    margin-left: 5px;
    font-weight: 500;
    color: #656565;
}

a {
    display: inline-block;
}

h5 {
    font-size: 14px;
    text-transform: capitalize;
    font-weight: 400;
    display: block;
    text-align: center;
    color: #000;

}

span strong {
    font-size: 20px;
    margin-top: 5px;
    display: block;
}

.arrow_block {
    display: none;
}

@media(max-width: 767px) {

    h4,
    h1 {
        font-size: 24px;
    }


}

@media(max-width: 512px) {
    span {
        text-align: center;
    }

    span strong {
        font-size: 16px;
    }

    /* -------------- */
    .arrow_block {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 90%;
        margin: 0 auto;
    }

    .slick_arrow_up,
    .slick_arrow_down {
        position: relative;
        border: 0;
    }

    .slick_arrow_up:before {
        position: absolute;
        content: "";
        height: 2px;
        width: 40px;
        background: #e2e2e2;
        top: -11px;
        left: 25px;
    }

    .slick_arrow_up:after {
        position: absolute;
        content: "";
        height: 6px;
        width: 6px;
        top: -13px;
        left: 25px;
        border-top: 2px solid #e2e2e2;
        border-right: 2px solid #e2e2e2;
        transform: rotate(-135deg);
    }

    .slick_arrow_down:before {
        position: absolute;
        content: "";
        height: 2px;
        width: 40px;
        background: #e2e2e2;
        top: -11px;
        right: 25px;
    }

    .slick_arrow_down:after {
        position: absolute;
        content: "";
        height: 6px;
        width: 6px;
        top: -13px;
        right: 25px;
        border-top: 2px solid #e2e2e2;
        border-right: 2px solid #e2e2e2;
        transform: rotate(45deg);
    }

    /* -------------- */

    .slick-slide.slick-active.slick-center.slick-current span {
        display: inline-block;

    }

    p,
    h5 {
        text-align: center;
    }


}
</style>
